export const categories = [
  {
    slug: 'tongren-manhua',
    name: '同人漫画',
    description: '精选雏田同人漫画作品，涵盖各种风格与题材的二次创作',
    icon: 'ri-book-open-line',
    count: 128,
  },
  {
    slug: 'chahua-zuopin',
    name: '插画作品',
    description: '高质量雏田同人插画合集，包含单幅与系列插画作品',
    icon: 'ri-image-line',
    count: 256,
  },
  {
    slug: 'duanpian-tongren',
    name: '短篇同人',
    description: '短小精悍的雏田同人短篇故事与四格漫画合集',
    icon: 'ri-file-text-line',
    count: 84,
  },
  {
    slug: 'tongren-xiaoshuo',
    name: '同人小说',
    description: '基于火影忍者世界观的雏田同人小说与轻小说作品',
    icon: 'ri-article-line',
    count: 67,
  },
  {
    slug: 'cosplay-sheying',
    name: 'Cosplay摄影',
    description: '雏田角色扮演摄影作品集，展现角色魅力的精美写真',
    icon: 'ri-camera-line',
    count: 43,
  },
  {
    slug: 'donghua-jianji',
    name: '动画剪辑',
    description: '火影忍者雏田精彩片段剪辑与同人动画短片合集',
    icon: 'ri-film-line',
    count: 36,
  },
];

export const articles = [
  {
    id: 1,
    title: '雏田的温柔守护 - 温馨日常同人漫画精选',
    slug: 'hinata-gentle-guardian',
    category: 'tongren-manhua',
    categoryName: '同人漫画',
    author: '风之漫画家',
    date: '2026-08-05',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20Hinata%20Hyuga%20from%20Naruto%20in%20a%20soft%20pastel%20watercolor%20art%20style%2C%20gentle%20expression%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20beautiful%20detailed%20character%20portrait%2C%20cream%20background%20with%20soft%20gradients&width=800&height=560&seq=article-01&orientation=landscape',
    excerpt: '本合集收录了多部以雏田温柔日常为主题的同人漫画，展现了她在木叶村中的温暖生活片段。从与鸣人的甜蜜互动到与伙伴们的温馨日常，每一页都充满了暖心的细节。',
    content: '雏田作为火影忍者中备受喜爱的角色，她的温柔与坚强一直是同人创作的热门主题。本合集精选了数十部以雏田日常生活为主题的同人漫画...',
    tags: ['雏田', '温馨', '日常', '鸣雏'],
    views: 12580,
    likes: 3420,
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '日向雏田战斗姿态 - 高燃插画作品集',
    slug: 'hinata-battle-pose-illustrations',
    category: 'chahua-zuopin',
    categoryName: '插画作品',
    author: '木叶画师联盟',
    date: '2026-08-03',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20action%20illustration%20of%20Hinata%20Hyuga%20in%20dynamic%20battle%20pose%2C%20Byakugan%20activated%2C%20Gentle%20Fist%20technique%2C%20energy%20effects%2C%20dramatic%20lighting%2C%20cool%20color%20tones%2C%20clean%20soft%20background%2C%20professional%20anime%20art%20quality&width=800&height=560&seq=article-02&orientation=landscape',
    excerpt: '收录了雏田在战斗中的高燃姿态插画，从白眼开启的战斗形态到柔拳八卦掌的精彩瞬间，展现了雏田作为日向宗家继承人的强大实力。',
    content: '雏田的战斗姿态一直是同人画师们热衷的创作题材。本作品集集结了来自全球画师的雏田战斗插画，涵盖了从疾风传到博人传的不同时期造型...',
    tags: ['雏田', '战斗', '白眼', '柔拳'],
    views: 18920,
    likes: 5680,
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '鸣人与雏田的爱情故事 - 长篇同人漫画连载',
    slug: 'naruhina-love-story',
    category: 'tongren-manhua',
    categoryName: '同人漫画',
    author: '星之同人社',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20Naruto%20and%20Hinata%20together%20under%20cherry%20blossom%20tree%2C%20holding%20hands%2C%20soft%20pink%20petals%2C%20golden%20hour%20warm%20lighting%2C%20sweet%20atmosphere%2C%20watercolor%20style%2C%20gentle%20composition%2C%20cream%20background&width=800&height=560&seq=article-03&orientation=landscape',
    excerpt: '这是一部以鸣人与雏田感情线为主轴的长篇同人漫画，从两人幼年初识到最终走到一起，细腻描绘了这段感人至深的爱情故事。',
    content: '鸣人与雏田的感情线是火影忍者中最受关注的情感线索之一。这部同人漫画从两人的童年时代讲起，一直延续到婚后生活...',
    tags: ['鸣雏', '爱情', '长篇', '连载'],
    views: 25630,
    likes: 8920,
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '雏田和服造型 - 传统日式美学插画特辑',
    slug: 'hinata-kimono-collection',
    category: 'chahua-zuopin',
    categoryName: '插画作品',
    author: '和风画集',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20illustration%20of%20Hinata%20Hyuga%20wearing%20beautiful%20traditional%20Japanese%20kimono%20with%20flower%20patterns%2C%20standing%20in%20Japanese%20garden%20with%20maple%20leaves%2C%20soft%20autumn%20lighting%2C%20graceful%20pose%2C%20detailed%20fabric%20texture%2C%20warm%20cream%20background&width=800&height=560&seq=article-04&orientation=landscape',
    excerpt: '当雏田穿上传统和服，日向家大小姐的优雅气质尽显无遗。本特辑收集了多位画师笔下的雏田和服造型，每一幅都充满了日式传统美学韵味。',
    content: '和服作为日本传统文化的象征，与雏田温婉的气质相得益彰。本特辑精选了不同季节、不同花色的雏田和服插画...',
    tags: ['雏田', '和服', '传统', '美学'],
    views: 15240,
    likes: 4560,
    featured: true,
    hot: false,
  },
  {
    id: 5,
    title: '火影忍者：雏田外传 - 同人短篇小说集',
    slug: 'hinata-gaiden-short-stories',
    category: 'duanpian-tongren',
    categoryName: '短篇同人',
    author: '月光下的忍道',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20Hinata%20Hyuga%20reading%20a%20scroll%20in%20a%20quiet%20room%20with%20soft%20candlelight%2C%20thoughtful%20expression%2C%20traditional%20Japanese%20interior%2C%20warm%20ambient%20lighting%2C%20storytelling%20atmosphere%2C%20gentle%20composition%2C%20cream%20background&width=800&height=560&seq=article-05&orientation=landscape',
    excerpt: '收录了五篇独立成章的雏田同人短篇小说，分别讲述了雏田不同阶段的故事——从下忍时期的成长烦恼到成为母亲后的温馨日常。',
    content: '这五篇短篇小说从不同角度切入雏田的内心世界。有的聚焦于她的童年回忆，有的描绘了她作为母亲的日常...',
    tags: ['雏田', '外传', '短篇', '小说'],
    views: 8340,
    likes: 2100,
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: '雏田柔拳秘传 - 同人漫画战斗特辑',
    slug: 'hinata-gentle-fist-special',
    category: 'tongren-manhua',
    categoryName: '同人漫画',
    author: '忍术工作室',
    date: '2026-07-22',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20anime%20action%20illustration%20of%20Hinata%20Hyuga%20using%20Gentle%20Fist%20technique%2C%20chakra%20energy%20flowing%2C%20dynamic%20combat%20pose%2C%20blue%20energy%20effects%2C%20intense%20expression%2C%20clean%20minimal%20background%2C%20professional%20anime%20art%20style&width=800&height=560&seq=article-06&orientation=landscape',
    excerpt: '深入探讨雏田柔拳技法的同人漫画特辑，从八卦掌到守护八卦六十四掌，完整展现了日向流柔拳的精髓与雏田的个人理解。',
    content: '柔拳是日向一族的招牌体术，而雏田在柔拳上的造诣更是令人刮目相看。本特辑从技法的角度出发...',
    tags: ['雏田', '柔拳', '战斗', '日向'],
    views: 11200,
    likes: 3250,
    featured: false,
    hot: true,
  },
  {
    id: 7,
    title: '雏田成长轨迹 - 从胆怯少女到坚强忍者的蜕变',
    slug: 'hinata-growth-journey',
    category: 'tongren-xiaoshuo',
    categoryName: '同人小说',
    author: '木叶文学社',
    date: '2026-07-18',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20showing%20Hinata%20Hyuga%20character%20development%20from%20shy%20girl%20to%20confident%20ninja%2C%20three%20stages%20of%20growth%2C%20soft%20watercolor%20style%2C%20warm%20inspiring%20tone%2C%20beautiful%20character%20design%2C%20cream%20background%20with%20subtle%20gradients&width=800&height=560&seq=article-07&orientation=landscape',
    excerpt: '一部深入剖析雏田角色成长弧光的同人小说，从她被族人看轻的童年到成为木叶村备受尊敬的优秀忍者，完整记录了她的蜕变之旅。',
    content: '雏田的成长是火影忍者中最动人的角色弧光之一。从一个缺乏自信、被父亲视为不合格继承人的少女...',
    tags: ['雏田', '成长', '蜕变', '励志'],
    views: 9760,
    likes: 2890,
    featured: true,
    hot: false,
  },
  {
    id: 8,
    title: '雏田Cosplay精选 - 白瞳美人的完美还原',
    slug: 'hinata-cosplay-highlights',
    category: 'cosplay-sheying',
    categoryName: 'Cosplay摄影',
    author: '次元摄影馆',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20cosplay%20photography%20of%20Hinata%20Hyuga%20character%2C%20professional%20studio%20lighting%2C%20detailed%20costume%20with%20long%20dark%20blue%20hair%2C%20white%20eyes%20contacts%2C%20elegant%20pose%2C%20Japanese%20style%20background%2C%20soft%20dreamy%20atmosphere%2C%20cream%20backdrop&width=800&height=560&seq=article-08&orientation=landscape',
    excerpt: '精选国内顶级Coser对雏田的精彩还原作品，从服装道具到妆容发型，每一个细节都力求完美呈现日向雏田的独特魅力。',
    content: 'Cosplay是将二次元角色带入现实的最好方式。本精选辑收录了多位知名Coser的雏田作品...',
    tags: ['雏田', 'Cosplay', '还原', '摄影'],
    views: 14320,
    likes: 4120,
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '木叶秘话：雏田的忍者修行日记',
    slug: 'hinata-training-diary',
    category: 'duanpian-tongren',
    categoryName: '短篇同人',
    author: '忍道记录者',
    date: '2026-07-12',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20Hinata%20Hyuga%20training%20in%20a%20bamboo%20forest%2C%20early%20morning%20mist%2C%20determined%20expression%2C%20practicing%20martial%20arts%2C%20soft%20morning%20sunlight%20through%20trees%2C%20peaceful%20atmosphere%2C%20warm%20cream%20background&width=800&height=560&seq=article-09&orientation=landscape',
    excerpt: '以日记体形式记录的雏田忍者修行日常，从晨练到任务执行，从与队友的互动到独处时的自我反思，充满生活气息的同人短篇。',
    content: '这本修行日记以雏田的第一人称视角展开，记录了她在成为上忍过程中的点点滴滴...',
    tags: ['雏田', '修行', '日记', '日常'],
    views: 6890,
    likes: 1780,
    featured: false,
    hot: false,
  },
];

export const heroSlides = [
  {
    title: '雏田本子精选合集',
    subtitle: '探索最全面的火影忍者雏田同人创作',
    description: '汇聚海量雏田同人漫画、插画与二次创作，为每一位火影粉丝精心呈现',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20artistic%20anime%20illustration%20of%20Hinata%20Hyuga%20from%20Naruto%20with%20long%20dark%20blue%20hair%20and%20white%20eyes%2C%20elegant%20traditional%20Japanese%20aesthetic%2C%20soft%20cherry%20blossom%20petals%2C%20warm%20golden%20sunset%20lighting%2C%20watercolor%20and%20ink%20wash%20painting%20style%2C%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20gentle%20expression&width=1600&height=800&seq=hero-main-01&orientation=landscape',
    cta: '开始探索',
  },
];

export const faqItems = [
  {
    question: '什么是雏田本子？',
    answer: '雏田本子是指以火影忍者中的日向雏田角色为主题的同人志（Doujinshi），包括同人漫画、插画集、短篇小说等二次创作作品。这些作品由粉丝自发创作，展现了雏田在官方剧情之外的各种故事和造型。',
  },
  {
    question: '如何浏览和查找特定类型的雏田同人作品？',
    answer: '您可以通过网站顶部的分类导航浏览不同类型的作品，包括同人漫画、插画作品、短篇同人、同人小说、Cosplay摄影和动画剪辑六大类别。每个分类下都有详细的子标签帮助您更精准地找到感兴趣的内容。',
  },
  {
    question: '网站上的同人作品是否可以下载？',
    answer: '本站作为同人作品的导览和推荐平台，提供作品的详细信息、预览图和推荐链接。具体的下载或购买方式请参考每篇作品的详细信息页面，我们会标注作品的来源和获取方式。',
  },
  {
    question: '如何投稿自己的雏田同人作品？',
    answer: '我们非常欢迎同人创作者的投稿！您可以通过关于我们页面中的联系方式与我们取得联系，提交您的作品信息和预览图。我们的编辑团队会在审核后与您确认收录事宜。',
  },
  {
    question: '网站内容是否定期更新？',
    answer: '是的，我们的编辑团队每周都会更新新的雏田同人作品推荐。您可以关注网站的"最新更新"板块，或者通过首页的订阅功能获取更新通知，确保不会错过任何精彩内容。',
  },
];

export const testimonials = [
  {
    name: '宇智波小枫',
    role: '火影粉丝 / 同人创作者',
    content: '这个网站简直是我的雏田同人宝库！分类清晰，推荐质量超高，每次来都能发现新的宝藏作品。作为同人创作者，这里也是我获取灵感的重要来源。',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20character%20avatar%20portrait%2C%20young%20person%2C%20warm%20friendly%20expression%2C%20simple%20clean%20style%2C%20soft%20lighting%2C%20cream%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '旗木悠里',
    role: '动漫文化研究者',
    content: '难得见到如此专业的同人作品聚合平台。不仅作品质量上乘，网站的设计和分类逻辑也非常清晰。对于研究火影同人文化的人来说，这是一个不可多得的资源库。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20anime%20style%20avatar%20portrait%2C%20scholarly%20look%2C%20glasses%2C%20warm%20smile%2C%20clean%20simple%20style%2C%20soft%20lighting%2C%20cream%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '漩涡鸣子',
    role: '资深火影粉丝',
    content: '关注这个网站快一年了，每次更新都不会错过。特别推荐给喜欢雏田的朋友们，这里的同人漫画区简直是天堂！鸣雏党的专属福利站，懂的都懂～',
    avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20anime%20style%20avatar%20portrait%2C%20young%20girl%20with%20energetic%20smile%2C%20casual%20style%2C%20warm%20lighting%2C%20clean%20simple%20design%2C%20cream%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];